import { URL_BACKEND } from "./urlBackend";

export const URL_LOGIN = `${URL_BACKEND}/login`;
